import React from "react";
import classNames from "classnames";
import Search from "storefront/components/Search";
import type { TabName } from "./index";

type Props = {
  selectedTab: TabName;
  onTabChange: (tab: TabName) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
};

const tabs: Array<TabName> = ["featured", "popular", "all"];

const RefineAndSearch = ({
  selectedTab,
  onTabChange,
  searchQuery,
  onSearchChange,
}: Props) => (
  <div className="refine-and-search-wrapper">
    <div className="refinements">
      {tabs.map((tab) => (
        /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        <h2
          className={classNames({ active: tab === selectedTab })}
          onClick={() => onTabChange(tab)}
          key={tab}
        >
          {tab}
        </h2>
        /* eslint-enable jsx-a11y/click-events-have-key-events */
        /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
      ))}
    </div>

    <Search
      searchCallback={() => {}}
      placeholder="Search"
      value={searchQuery}
      onChange={onSearchChange}
      onClear={() => onSearchChange("")}
    />
  </div>
);

export default RefineAndSearch;
